angular
  .module("admin.reports")
  .controller(
    "FavoritesReportCtrl",
    function ($http, config, ReportsResource, dateFilter) {
      this.page = 1;
      this.pageSize = 20;

      this.loadChart = function () {
        $http({
          url: config.api + "/api/v1/reports/favorite-posts/chart",
          method: "GET",
        }).then((response) => {
          let data = response.data.data || response.data;
          if (!Array.isArray(data)) {
            data = [];
          }
          data = data.reverse();
          this.monthlyChart = {
            chart: {
              type: "line",
            },
            xAxis: {
              categories: data.map((p) => dateFilter(p.period, "MMM/yyyy")),
            },
            series: [
              {
                data: data.map((c) => c.posts),
                id: "posts_per_month",
                name: "Postagens favoritadas",
              },
            ],
            title: {
              text: "Matérias favoritadas por mês",
            },
          };
        });
      };

      this.loadTable = function () {
        $http({
          url: config.api + "/api/v1/reports/favorite-posts",
          method: "GET",
          params: {
            page: this.page,
            pageSize: this.pageSize,
          },
        }).then((response) => {
          const data = response.data.data;
          this.report = {
            results: data.data,
            totalResults: data.metadata.total,
            pageSize: data.metadata.limit,
          };
        });
      };

      this.exportToExcel = function () {
        this.isExporting = true;
        $http({
          url: config.api + "/api/v1/reports/favorite-posts/export",
          method: "GET",
          responseType: "arraybuffer",
        }).then(
          (res) => {
            const downloadFile = ({ blob, fileName }) => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");

              a.href = url;
              a.download = fileName;

              a.dispatchEvent(
                new MouseEvent("click", {
                  view: window,
                  bubbles: true,
                  cancelable: false,
                })
              );

              window.URL.revokeObjectURL(url);
            };

            this.isExporting = false;
            const blob = new Blob([res.data], {
              type: "text/csv;charset=utf-8;",
            });
            downloadFile({ blob: blob, fileName: "QuemFavorita.csv" });
          },
          (error) => {
            console.error("[FavoritesReportCtrl] Erro ao exportar:", error);
            this.isExporting = false;
          }
        );
      };

      this.init = function () {
        this.loadChart();
        this.loadTable();
      };

      this.init();
    }
  );
